<template>
  <!-- begin:: Page -->
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
    <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v3 kt-login--signin" id="kt_login">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" style="background-image: url(../../assets/v6.05/media/bg/bg-9.jpg);">
        <div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
          <div class="kt-login__container">
            <div class="kt-login__logo">
              <a href="/">
<!--                <img src="../../assets/v6.05/media/logos/logo-5.png">-->
                <img src="../../assets/img/logo/bylogo120.png">
              </a>
            </div>

            <!--  登录  begin-->
            <div class="kt-login__signin" v-if="loginIsShow===1">
              <div class="kt-login__head">
                <h3 class="kt-login__title">欢迎登陆百驿学院</h3>
              </div>
              <el-form :model="loginForm" status-icon class="kt-form" label-width="0px" :rules="rules" ref="loginForm">
                <el-form-item  prop="phone">
                  <el-input  placeholder="手机号" v-model="loginForm.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  prop="password" autocomplete="off">
                  <el-input  placeholder="密码" type="password" v-model="loginForm.password">
                  </el-input>
                </el-form-item>
              </el-form>
              <form class="kt-form"   action="">


                <div class="row kt-login__extra">
<!--                  <div class="col">-->
<!--                    <label class="kt-checkbox">-->
<!--                      <input type="checkbox" name="remember"> 记住我-->
<!--                      <span></span>-->
<!--                    </label>-->
<!--                  </div>-->
<!--                  <div class="col kt-align-right">-->
<!--                    <a href="b100y:;" id="kt_login_forgot" class="kt-login__link">忘记密码 ?</a>-->
<!--                  </div>-->
                </div>
                <div class="kt-login__actions">
                  <button type="button" class="btn btn-brand btn-elevate kt-login__btn-primary" @click="handleLogin">登陆</button>&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="button"  class="btn btn-light btn-elevate kt-login__btn-secondary" @click="signUp(0)">注册</button>
                </div>
              </form>
            </div>
            <!--  登录  End-->

            <!--  注册  begin-->

            <div class="kt-login__signup" v-if="loginIsShow===0">
              <div class="kt-login__head">
                <h3 class="kt-login__title">用户注册</h3>
                <div class="kt-login__desc">输入您的详细资料创建帐户：</div>
              </div>
              <el-form :model="registerForm"  class="kt-form" label-width="0px" :rules="rules" ref="registerForm">
                <el-form-item  prop="nickname" autocomplete="off">
                  <el-input  placeholder="用户名" type="text" v-model="registerForm.nickname">
                  </el-input>
                </el-form-item>
                <el-form-item  prop="phone">
                  <el-input  placeholder="手机号" v-model="registerForm.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  prop="email" autocomplete="off">
                  <el-input  placeholder="邮箱" type="text" v-model="registerForm.email">
                  </el-input>
                </el-form-item>
                <el-form-item  prop="username" autocomplete="off">
                  <el-input  placeholder="真实姓名" type="text" v-model="registerForm.username">
                  </el-input>
                </el-form-item>
                <el-form-item  prop="password" autocomplete="off">
                  <el-input  placeholder="密码" type="password" v-model="registerForm.password">
                  </el-input>
                </el-form-item>
                <el-form-item  prop="resPassword" autocomplete="off">
                  <el-input  placeholder="确认密码" type="password" v-model="registerForm.resPassword">
                  </el-input>
                </el-form-item>
                <el-form-item  prop="verificationCode" autocomplete="off">
                  <el-input  placeholder="验证码" type="text" v-model="registerForm.verificationCode">
                    <el-button v-if="showtime===null" slot="suffix" type="info" @click="send">获取验证码</el-button>
                    <el-button v-else slot="suffix" type="info" disabled>{{showtime}}</el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <form class="kt-form" action="">
                <div class="row kt-login__extra">
<!--                  <div class="col kt-align-left">-->
<!--                    <label class="kt-checkbox">-->
<!--                      <input type="checkbox" name="agree">I Agree the <a href="#" class="kt-link kt-login__link kt-font-bold">terms and conditions</a>.-->
<!--                      <span></span>-->
<!--                    </label>-->
<!--                    <span class="form-text text-muted"></span>-->
<!--                  </div>-->
                </div>
                <div class="kt-login__actions">
                  <button type="button" id="kt_login_signup_submit" class="btn btn-brand btn-elevate kt-login__btn-primary" @click="register">注册</button>&nbsp;&nbsp;
                  <button type="button" class="btn btn-light btn-elevate kt-login__btn-secondary" @click="signUp(1)">取消</button>
                </div>
              </form>
            </div>
            <!--  注册  End-->


            <div class="kt-login__forgot">
              <div class="kt-login__head">
<!--                <h3 class="kt-login__title">Forgotten Password ?</h3>-->
<!--                <div class="kt-login__desc">Enter your email to reset your password:</div>-->
              </div>
              <form class="kt-form" action="">
                <div class="input-group">
                  <input class="form-control" type="text" placeholder="Email" name="email" id="kt_email" autocomplete="off">
                </div>
                <div class="kt-login__actions">
                  <button id="kt_login_forgot_submit" class="btn btn-brand btn-elevate kt-login__btn-primary">Request</button>&nbsp;&nbsp;
                  <button id="kt_login_forgot_cancel" class="btn btn-light btn-elevate kt-login__btn-secondary">Cancel</button>
                </div>
              </form>
            </div>
            <div class="kt-login__account" v-if="loginIsShow===1">
<!--              <span class="kt-login__account-msg">-->
<!--                Don't have an account yet ?-->
<!--              </span>-->
                  &nbsp;&nbsp;
<!--                  <a href="javascript:;" id="kt_login_signup" class="kt-login__account-link" @click="signUp(0)" >Sign Up!</a>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/index.css';
  import '../../assets/v6.05/css/demo4/pages/login/login-3.css'
  import '../../assets/v6.05/vendors/global/vendors.bundle.css'
  import '../../assets/v6.05/css/demo4/style.bundle.css'
  import { sendSMS ,registerMember} from "../../api/user";

  export default {
      name: "index",
      data(){
        const validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.registerForm.password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        }
        return {
          // 计时器,注意需要进行销毁
          timeCounter: null,
          // null 则显示按钮 秒数则显示读秒
          showtime: null,
          buttonInfo: '获取验证码',
          loginIsShow: 1,
          loginForm: {
            phone: '',
            password: ''
          },
          registerForm: {
            nickname:'',
            phone:'',
            email:'',
            password:'',
            username:'',
            verificationCode: '',
            icon: 'avator.jpg'
          },
          loading: false,
          redirect: undefined,
          rules: {
            nickname: [
              {required: true, message: '不能为空', trigger: 'blur'},
              {
                pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]{2,8}$/,
                message: '只含有汉字、数字、字母、下划线,长度在2~8 之间',
                trigger: 'blur'
              }
            ],
            phone: [
              {required: true, message: '不能为空', trigger: 'blur'},
              {
                pattern: /^((1[3,5,8][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/,
                message: '请输入正确的手机号',
                trigger: 'blur'
              }
            ],
            password: [
              {required: true, message: '请输入密码', trigger: 'blur'},
              {min: 6, max: 15, message: '请输入6-15位密码', trigger: 'blur'}
            ],
            resPassword: [
              {validator: validatePass, trigger: 'blur'}
            ],
            email: [
              {required: true, message: '请输入邮箱', trigger: 'blur'},
              {type:'email',message: '邮箱格式不对', trigger: 'blur'},
            ],
            username: [
              {required: true, message: '请输入姓名', trigger: 'blur'}
            ],
            verificationCode:[
              {required: true, message: '不能为空', trigger: 'blur'}
            ]
          }

        }
      },
      watch: {
        $route: {
          handler: function(route) {
            this.redirect = route.query && route.query.redirect
          },
          immediate: true
        }
      },
      methods:{
        signUp(val){
          this.loginIsShow = val
         },
        handleLogin() {
          this.$refs.loginForm.validate(valid => {
            if (valid) {
              this.loading = true
              this.$store.dispatch('user/login', this.loginForm).then(() => {
               this.$router.push({ path: this.redirect || '/' })
                // this.$router.go(0)
                this.loading = false
              }).catch(() => {
                this.loading = false
              })
            } else {
              this.$message({
                type: 'warning',
                message: '输入格式不正确'
              })
            }
          })
        },
        // 倒计时显示处理
        countDownText(s) {
          this.showtime = `${s}s后重新获取`
        },
        // 倒计时 60秒 不需要很精准
        countDown(times) {
          const self = this;
          // 时间间隔 1秒
          const interval = 1000;
          let count = 0;
          self.timeCounter = setTimeout(countDownStart, interval);
          function countDownStart() {
            if (self.timeCounter == null) {
              return false;
            }
            count++
            self.countDownText(times - count + 1);
            if (count > times) {
              clearTimeout(self.timeCounter)
              self.showtime = null;
            } else {
              self.timeCounter = setTimeout(countDownStart, interval)
            }
          }
        },
        send() {

          if(this.registerForm.phone===''){
            this.$message({
              type: 'warning',
              message: '请输入手机号'
            })
          }else{
            this.countDown(60);
            sendSMS(this.registerForm.phone).then(res=>{
              if(res.code===20000 && res.data===true){
                this.$message({
                  type: 'success',
                  message: res.message
                })
              }else{
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            })
          }
        },
        register(){
          this.$refs.registerForm.validate(valid => {
            if (valid){
              registerMember(this.registerForm).then(res=>{
                if(res.code===20000){
                  this.$message({
                    type: 'success',
                    message: res.message
                  })
                  this.loginIsShow=1
                }
              })
            }else {
              this.$message({
                type: 'warning',
                message: '输入格式不正确'
              })
            }
          })

        }
      }
    }
</script>
<style scoped>
  .kt-login__signup{
    display: block !important;
  }
  .kt-form >>> .el-input__inner{
    height: 46px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    margin-top: 0px;
    border: 0px solid #DCDFE6 !important;
    background-color: #f3f4f8 !important;
  }
  .el-button{
    padding: 14px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue